// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Deafult Margin & Padding */
/*-- Margin Top --*/
.mt-5 {
	margin-top: 5px;
}
.mt-10 {
	margin-top: 10px;
}
.mt-15 {
	margin-top: 15px;
}
.mt-20 {
	margin-top: 20px;
}
.mt-25 {
	margin-top: 25px;
}
.mt-30 {
	margin-top: 30px;
}
.mt-35 {
	margin-top: 35px;
}
.mt-40 {
	margin-top: 40px;
}
.mt-45 {
	margin-top: 45px;
}
.mt-50 {
	margin-top: 50px;
}
.mt-55 {
	margin-top: 55px;
}
.mt-60 {
	margin-top: 60px;
}
.mt-65 {
	margin-top: 65px;
}
.mt-70 {
	margin-top: 70px;
}
.mt-75 {
	margin-top: 75px;
}
.mt-80 {
	margin-top: 80px;
}
.mt-85 {
	margin-top: 85px;
}
.mt-90 {
	margin-top: 90px;
}
.mt-95 {
	margin-top: 95px;
}
.mt-100 {
	margin-top: 100px;
}
.mt-105 {
	margin-top: 105px;
}
.mt-110 {
	margin-top: 110px;
}
.mt-115 {
	margin-top: 115px;
}
.mt-120 {
	margin-top: 120px;
}
.mt-125 {
	margin-top: 125px;
}
.mt-130 {
	margin-top: 130px;
}
.mt-135 {
	margin-top: 135px;
}
.mt-140 {
	margin-top: 140px;
}
.mt-145 {
	margin-top: 145px;
}
.mt-150 {
	margin-top: 150px;
}
.mt-155 {
	margin-top: 155px;
}
.mt-160 {
	margin-top: 160px;
}
.mt-165 {
	margin-top: 165px;
}
.mt-170 {
	margin-top: 170px;
}
.mt-175 {
	margin-top: 175px;
}
.mt-180 {
	margin-top: 180px;
}
.mt-185 {
	margin-top: 185px;
}
.mt-190 {
	margin-top: 190px;
}
.mt-195 {
	margin-top: 195px;
}
.mt-200 {
	margin-top: 200px;
}
/*-- Margin Bottom --*/

.mb-5 {
	margin-bottom: 5px;
}
.mb-10 {
	margin-bottom: 10px;
}
.mb-15 {
	margin-bottom: 15px;
}
.mb-20 {
	margin-bottom: 20px;
}
.mb-25 {
	margin-bottom: 25px;
}
.mb-30 {
	margin-bottom: 30px;
}
.mb-35 {
	margin-bottom: 35px;
}
.mb-40 {
	margin-bottom: 40px;
}
.mb-45 {
	margin-bottom: 45px;
}
.mb-50 {
	margin-bottom: 50px;
}
.mb-55 {
	margin-bottom: 55px;
}
.mb-60 {
	margin-bottom: 60px;
}
.mb-65 {
	margin-bottom: 65px;
}
.mb-70 {
	margin-bottom: 70px;
}
.mb-75 {
	margin-bottom: 75px;
}
.mb-80 {
	margin-bottom: 80px;
}
.mb-85 {
	margin-bottom: 85px;
}
.mb-90 {
	margin-bottom: 90px;
}
.mb-95 {
	margin-bottom: 95px;
}
.mb-100 {
	margin-bottom: 100px;
}
.mb-105 {
	margin-bottom: 105px;
}
.mb-110 {
	margin-bottom: 110px;
}
.mb-115 {
	margin-bottom: 115px;
}
.mb-120 {
	margin-bottom: 120px;
}
.mb-125 {
	margin-bottom: 125px;
}
.mb-130 {
	margin-bottom: 130px;
}
.mb-135 {
	margin-bottom: 135px;
}
.mb-140 {
	margin-bottom: 140px;
}
.mb-145 {
	margin-bottom: 145px;
}
.mb-150 {
	margin-bottom: 150px;
}
.mb-155 {
	margin-bottom: 155px;
}
.mb-160 {
	margin-bottom: 160px;
}
.mb-165 {
	margin-bottom: 165px;
}
.mb-170 {
	margin-bottom: 170px;
}
.mb-175 {
	margin-bottom: 175px;
}
.mb-180 {
	margin-bottom: 180px;
}
.mb-185 {
	margin-bottom: 185px;
}
.mb-190 {
	margin-bottom: 190px;
}
.mb-195 {
	margin-bottom: 195px;
}
.mb-200 {
	margin-bottom: 200px;
}
/*-- Padding Top --*/

.pt-5 {
	padding-top: 5px;
}
.pt-10 {
	padding-top: 10px;
}
.pt-15 {
	padding-top: 15px;
}
.pt-20 {
	padding-top: 20px;
}
.pt-25 {
	padding-top: 25px;
}
.pt-30 {
	padding-top: 30px;
}
.pt-35 {
	padding-top: 35px;
}
.pt-40 {
	padding-top: 40px;
}
.pt-45 {
	padding-top: 45px;
}
.pt-50 {
	padding-top: 50px;
}
.pt-55 {
	padding-top: 55px;
}
.pt-60 {
	padding-top: 60px;
}
.pt-65 {
	padding-top: 65px;
}
.pt-70 {
	padding-top: 70px;
}
.pt-75 {
	padding-top: 75px;
}
.pt-80 {
	padding-top: 80px;
}
.pt-85 {
	padding-top: 85px;
}
.pt-90 {
	padding-top: 90px;
}
.pt-95 {
	padding-top: 95px;
}
.pt-100 {
	padding-top: 100px;
}
.pt-105 {
	padding-top: 105px;
}
.pt-110 {
	padding-top: 110px;
}
.pt-115 {
	padding-top: 115px;
}
.pt-120 {
	padding-top: 120px;
}
.pt-125 {
	padding-top: 125px;
}
.pt-130 {
	padding-top: 130px;
}
.pt-135 {
	padding-top: 135px;
}
.pt-140 {
	padding-top: 140px;
}
.pt-145 {
	padding-top: 145px;
}
.pt-150 {
	padding-top: 150px;
}
.pt-155 {
	padding-top: 155px;
}
.pt-160 {
	padding-top: 160px;
}
.pt-165 {
	padding-top: 165px;
}
.pt-170 {
	padding-top: 170px;
}
.pt-175 {
	padding-top: 175px;
}
.pt-180 {
	padding-top: 180px;
}
.pt-185 {
	padding-top: 185px;
}
.pt-190 {
	padding-top: 190px;
}
.pt-195 {
	padding-top: 195px;
}
.pt-200 {
	padding-top: 200px;
}
/*-- Padding Bottom --*/

.pb-5 {
	padding-bottom: 5px;
}
.pb-10 {
	padding-bottom: 10px;
}
.pb-15 {
	padding-bottom: 15px;
}
.pb-20 {
	padding-bottom: 20px;
}
.pb-25 {
	padding-bottom: 25px;
}
.pb-30 {
	padding-bottom: 30px;
}
.pb-35 {
	padding-bottom: 35px;
}
.pb-40 {
	padding-bottom: 40px;
}
.pb-45 {
	padding-bottom: 45px;
}
.pb-50 {
	padding-bottom: 50px;
}
.pb-55 {
	padding-bottom: 55px;
}
.pb-60 {
	padding-bottom: 60px;
}
.pb-65 {
	padding-bottom: 65px;
}
.pb-70 {
	padding-bottom: 70px;
}
.pb-75 {
	padding-bottom: 75px;
}
.pb-80 {
	padding-bottom: 80px;
}
.pb-85 {
	padding-bottom: 85px;
}
.pb-90 {
	padding-bottom: 90px;
}
.pb-95 {
	padding-bottom: 95px;
}
.pb-100 {
	padding-bottom: 100px;
}
.pb-105 {
	padding-bottom: 105px;
}
.pb-110 {
	padding-bottom: 110px;
}
.pb-115 {
	padding-bottom: 115px;
}
.pb-120 {
	padding-bottom: 120px;
}
.pb-125 {
	padding-bottom: 125px;
}
.pb-130 {
	padding-bottom: 130px;
}
.pb-135 {
	padding-bottom: 135px;
}
.pb-140 {
	padding-bottom: 140px;
}
.pb-145 {
	padding-bottom: 145px;
}
.pb-150 {
	padding-bottom: 150px;
}
.pb-155 {
	padding-bottom: 155px;
}
.pb-160 {
	padding-bottom: 160px;
}
.pb-165 {
	padding-bottom: 165px;
}
.pb-170 {
	padding-bottom: 170px;
}
.pb-175 {
	padding-bottom: 175px;
}
.pb-180 {
	padding-bottom: 180px;
}
.pb-185 {
	padding-bottom: 185px;
}
.pb-190 {
	padding-bottom: 190px;
}
.pb-195 {
	padding-bottom: 195px;
}
.pb-200 {
	padding-bottom: 200px;
}



/*-- Padding Left --*/
.pl-0 {
	padding-left: 0px;
}
.pl-5 {
	padding-left: 5px;
}
.pl-10 {
	padding-left: 10px;
}
.pl-15 {
	padding-left: 15px;
}
.pl-20{
	padding-left: 20px;
}
.pl-25 {
	padding-left: 35px;
}
.pl-30 {
	padding-left: 30px;
}
.pl-35 {
	padding-left: 35px;
}

.pl-35 {
	padding-left: 35px;
}

.pl-40 {
	padding-left: 40px;
}

.pl-45 {
	padding-left: 45px;
}

.pl-50 {
	padding-left: 50px;
}

.pl-55 {
	padding-left: 55px;
}

.pl-60 {
	padding-left: 60px;
}
.pl-65 {
	padding-left: 65px;
}
.pl-70 {
	padding-left: 70px;
}
.pl-75 {
	padding-left: 75px;
}
.pl-80 {
	padding-left: 80px;
}
.pl-85 {
	padding-left: 80px;
}
.pl-90 {
	padding-left: 90px;
}
.pl-95 {
	padding-left: 95px;
}
.pl-100 {
	padding-left: 100px;
}


/*-- Padding Right --*/
.pr-0 {
	padding-right: 0px;
}
.pr-5 {
	padding-right: 5px;
}
.pr-10 {
	padding-right: 10px;
}
.pr-15 {
	padding-right: 15px;
}
.pr-20{
	padding-right: 20px;
}
.pr-25 {
	padding-right: 35px;
}
.pr-30 {
	padding-right: 30px;
}
.pr-35 {
	padding-right: 35px;
}

.pr-35 {
	padding-right: 35px;
}

.pr-40 {
	padding-right: 40px;
}

.pr-45 {
	padding-right: 45px;
}

.pr-50 {
	padding-right: 50px;
}

.pr-55 {
	padding-right: 55px;
}

.pr-60 {
	padding-right: 60px;
}
.pr-65 {
	padding-right: 65px;
}
.pr-70 {
	padding-right: 70px;
}
.pr-75 {
	padding-right: 75px;
}
.pr-80 {
	padding-right: 80px;
}
.pr-85 {
	padding-right: 80px;
}
.pr-90 {
	padding-right: 90px;
}
.pr-95 {
	padding-right: 95px;
}
.pr-100 {
	padding-right: 100px;
}

/* font weight */
.f-700{font-weight: 700;}
.f-600{font-weight: 600;}
.f-500{font-weight: 500;}
.f-400{font-weight: 400;}
.f-300{font-weight: 300;}

/* Background Color */

.gray-bg {
	background: #f7f7fd;
}
.white-bg {
	background: #fff;
}
.black-bg {
	background: #222;
}
.theme-bg {
	background: #222;
}
.primary-bg {
	background: #222;
}
/* Color */

.white-color {
	color: #fff;
}
.black-color {
	color: #222;
}
.theme-color {
	color: #222;
}
.primary-color {
	color: #222;
}
/* black overlay */

[data-overlay] {
	position: relative;
}
[data-overlay]::before {
	background: #000 none repeat scroll 0 0;
	content: "";
	height: 100%;
	left: 0;
	position: absolute;
	top: 0;
	width: 100%;
	z-index: 1;
}
[data-overlay="3"]::before {
	opacity: 0.3;
}
[data-overlay="4"]::before {
	opacity: 0.4;
}
[data-overlay="5"]::before {
	opacity: 0.5;
}
[data-overlay="6"]::before {
	opacity: 0.6;
}
[data-overlay="7"]::before {
	opacity: 0.7;
}
[data-overlay="8"]::before {
	opacity: 0.8;
}
[data-overlay="9"]::before {
	opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/default.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B,mBAAmB;AACnB;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA,sBAAsB;;AAEtB;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA,oBAAoB;;AAEpB;CACC,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA,uBAAuB;;AAEvB;CACC,mBAAmB;AACpB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;;;;AAIA,qBAAqB;AACrB;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;;;AAGA,sBAAsB;AACtB;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,oBAAoB;AACrB;;AAEA,gBAAgB;AAChB,OAAO,gBAAgB,CAAC;AACxB,OAAO,gBAAgB,CAAC;AACxB,OAAO,gBAAgB,CAAC;AACxB,OAAO,gBAAgB,CAAC;AACxB,OAAO,gBAAgB,CAAC;;AAExB,qBAAqB;;AAErB;CACC,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA,UAAU;;AAEV;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA,kBAAkB;;AAElB;CACC,kBAAkB;AACnB;AACA;CACC,uCAAuC;CACvC,WAAW;CACX,YAAY;CACZ,OAAO;CACP,kBAAkB;CAClB,MAAM;CACN,WAAW;CACX,UAAU;AACX;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb","sourcesContent":["/* Deafult Margin & Padding */\n/*-- Margin Top --*/\n.mt-5 {\n\tmargin-top: 5px;\n}\n.mt-10 {\n\tmargin-top: 10px;\n}\n.mt-15 {\n\tmargin-top: 15px;\n}\n.mt-20 {\n\tmargin-top: 20px;\n}\n.mt-25 {\n\tmargin-top: 25px;\n}\n.mt-30 {\n\tmargin-top: 30px;\n}\n.mt-35 {\n\tmargin-top: 35px;\n}\n.mt-40 {\n\tmargin-top: 40px;\n}\n.mt-45 {\n\tmargin-top: 45px;\n}\n.mt-50 {\n\tmargin-top: 50px;\n}\n.mt-55 {\n\tmargin-top: 55px;\n}\n.mt-60 {\n\tmargin-top: 60px;\n}\n.mt-65 {\n\tmargin-top: 65px;\n}\n.mt-70 {\n\tmargin-top: 70px;\n}\n.mt-75 {\n\tmargin-top: 75px;\n}\n.mt-80 {\n\tmargin-top: 80px;\n}\n.mt-85 {\n\tmargin-top: 85px;\n}\n.mt-90 {\n\tmargin-top: 90px;\n}\n.mt-95 {\n\tmargin-top: 95px;\n}\n.mt-100 {\n\tmargin-top: 100px;\n}\n.mt-105 {\n\tmargin-top: 105px;\n}\n.mt-110 {\n\tmargin-top: 110px;\n}\n.mt-115 {\n\tmargin-top: 115px;\n}\n.mt-120 {\n\tmargin-top: 120px;\n}\n.mt-125 {\n\tmargin-top: 125px;\n}\n.mt-130 {\n\tmargin-top: 130px;\n}\n.mt-135 {\n\tmargin-top: 135px;\n}\n.mt-140 {\n\tmargin-top: 140px;\n}\n.mt-145 {\n\tmargin-top: 145px;\n}\n.mt-150 {\n\tmargin-top: 150px;\n}\n.mt-155 {\n\tmargin-top: 155px;\n}\n.mt-160 {\n\tmargin-top: 160px;\n}\n.mt-165 {\n\tmargin-top: 165px;\n}\n.mt-170 {\n\tmargin-top: 170px;\n}\n.mt-175 {\n\tmargin-top: 175px;\n}\n.mt-180 {\n\tmargin-top: 180px;\n}\n.mt-185 {\n\tmargin-top: 185px;\n}\n.mt-190 {\n\tmargin-top: 190px;\n}\n.mt-195 {\n\tmargin-top: 195px;\n}\n.mt-200 {\n\tmargin-top: 200px;\n}\n/*-- Margin Bottom --*/\n\n.mb-5 {\n\tmargin-bottom: 5px;\n}\n.mb-10 {\n\tmargin-bottom: 10px;\n}\n.mb-15 {\n\tmargin-bottom: 15px;\n}\n.mb-20 {\n\tmargin-bottom: 20px;\n}\n.mb-25 {\n\tmargin-bottom: 25px;\n}\n.mb-30 {\n\tmargin-bottom: 30px;\n}\n.mb-35 {\n\tmargin-bottom: 35px;\n}\n.mb-40 {\n\tmargin-bottom: 40px;\n}\n.mb-45 {\n\tmargin-bottom: 45px;\n}\n.mb-50 {\n\tmargin-bottom: 50px;\n}\n.mb-55 {\n\tmargin-bottom: 55px;\n}\n.mb-60 {\n\tmargin-bottom: 60px;\n}\n.mb-65 {\n\tmargin-bottom: 65px;\n}\n.mb-70 {\n\tmargin-bottom: 70px;\n}\n.mb-75 {\n\tmargin-bottom: 75px;\n}\n.mb-80 {\n\tmargin-bottom: 80px;\n}\n.mb-85 {\n\tmargin-bottom: 85px;\n}\n.mb-90 {\n\tmargin-bottom: 90px;\n}\n.mb-95 {\n\tmargin-bottom: 95px;\n}\n.mb-100 {\n\tmargin-bottom: 100px;\n}\n.mb-105 {\n\tmargin-bottom: 105px;\n}\n.mb-110 {\n\tmargin-bottom: 110px;\n}\n.mb-115 {\n\tmargin-bottom: 115px;\n}\n.mb-120 {\n\tmargin-bottom: 120px;\n}\n.mb-125 {\n\tmargin-bottom: 125px;\n}\n.mb-130 {\n\tmargin-bottom: 130px;\n}\n.mb-135 {\n\tmargin-bottom: 135px;\n}\n.mb-140 {\n\tmargin-bottom: 140px;\n}\n.mb-145 {\n\tmargin-bottom: 145px;\n}\n.mb-150 {\n\tmargin-bottom: 150px;\n}\n.mb-155 {\n\tmargin-bottom: 155px;\n}\n.mb-160 {\n\tmargin-bottom: 160px;\n}\n.mb-165 {\n\tmargin-bottom: 165px;\n}\n.mb-170 {\n\tmargin-bottom: 170px;\n}\n.mb-175 {\n\tmargin-bottom: 175px;\n}\n.mb-180 {\n\tmargin-bottom: 180px;\n}\n.mb-185 {\n\tmargin-bottom: 185px;\n}\n.mb-190 {\n\tmargin-bottom: 190px;\n}\n.mb-195 {\n\tmargin-bottom: 195px;\n}\n.mb-200 {\n\tmargin-bottom: 200px;\n}\n/*-- Padding Top --*/\n\n.pt-5 {\n\tpadding-top: 5px;\n}\n.pt-10 {\n\tpadding-top: 10px;\n}\n.pt-15 {\n\tpadding-top: 15px;\n}\n.pt-20 {\n\tpadding-top: 20px;\n}\n.pt-25 {\n\tpadding-top: 25px;\n}\n.pt-30 {\n\tpadding-top: 30px;\n}\n.pt-35 {\n\tpadding-top: 35px;\n}\n.pt-40 {\n\tpadding-top: 40px;\n}\n.pt-45 {\n\tpadding-top: 45px;\n}\n.pt-50 {\n\tpadding-top: 50px;\n}\n.pt-55 {\n\tpadding-top: 55px;\n}\n.pt-60 {\n\tpadding-top: 60px;\n}\n.pt-65 {\n\tpadding-top: 65px;\n}\n.pt-70 {\n\tpadding-top: 70px;\n}\n.pt-75 {\n\tpadding-top: 75px;\n}\n.pt-80 {\n\tpadding-top: 80px;\n}\n.pt-85 {\n\tpadding-top: 85px;\n}\n.pt-90 {\n\tpadding-top: 90px;\n}\n.pt-95 {\n\tpadding-top: 95px;\n}\n.pt-100 {\n\tpadding-top: 100px;\n}\n.pt-105 {\n\tpadding-top: 105px;\n}\n.pt-110 {\n\tpadding-top: 110px;\n}\n.pt-115 {\n\tpadding-top: 115px;\n}\n.pt-120 {\n\tpadding-top: 120px;\n}\n.pt-125 {\n\tpadding-top: 125px;\n}\n.pt-130 {\n\tpadding-top: 130px;\n}\n.pt-135 {\n\tpadding-top: 135px;\n}\n.pt-140 {\n\tpadding-top: 140px;\n}\n.pt-145 {\n\tpadding-top: 145px;\n}\n.pt-150 {\n\tpadding-top: 150px;\n}\n.pt-155 {\n\tpadding-top: 155px;\n}\n.pt-160 {\n\tpadding-top: 160px;\n}\n.pt-165 {\n\tpadding-top: 165px;\n}\n.pt-170 {\n\tpadding-top: 170px;\n}\n.pt-175 {\n\tpadding-top: 175px;\n}\n.pt-180 {\n\tpadding-top: 180px;\n}\n.pt-185 {\n\tpadding-top: 185px;\n}\n.pt-190 {\n\tpadding-top: 190px;\n}\n.pt-195 {\n\tpadding-top: 195px;\n}\n.pt-200 {\n\tpadding-top: 200px;\n}\n/*-- Padding Bottom --*/\n\n.pb-5 {\n\tpadding-bottom: 5px;\n}\n.pb-10 {\n\tpadding-bottom: 10px;\n}\n.pb-15 {\n\tpadding-bottom: 15px;\n}\n.pb-20 {\n\tpadding-bottom: 20px;\n}\n.pb-25 {\n\tpadding-bottom: 25px;\n}\n.pb-30 {\n\tpadding-bottom: 30px;\n}\n.pb-35 {\n\tpadding-bottom: 35px;\n}\n.pb-40 {\n\tpadding-bottom: 40px;\n}\n.pb-45 {\n\tpadding-bottom: 45px;\n}\n.pb-50 {\n\tpadding-bottom: 50px;\n}\n.pb-55 {\n\tpadding-bottom: 55px;\n}\n.pb-60 {\n\tpadding-bottom: 60px;\n}\n.pb-65 {\n\tpadding-bottom: 65px;\n}\n.pb-70 {\n\tpadding-bottom: 70px;\n}\n.pb-75 {\n\tpadding-bottom: 75px;\n}\n.pb-80 {\n\tpadding-bottom: 80px;\n}\n.pb-85 {\n\tpadding-bottom: 85px;\n}\n.pb-90 {\n\tpadding-bottom: 90px;\n}\n.pb-95 {\n\tpadding-bottom: 95px;\n}\n.pb-100 {\n\tpadding-bottom: 100px;\n}\n.pb-105 {\n\tpadding-bottom: 105px;\n}\n.pb-110 {\n\tpadding-bottom: 110px;\n}\n.pb-115 {\n\tpadding-bottom: 115px;\n}\n.pb-120 {\n\tpadding-bottom: 120px;\n}\n.pb-125 {\n\tpadding-bottom: 125px;\n}\n.pb-130 {\n\tpadding-bottom: 130px;\n}\n.pb-135 {\n\tpadding-bottom: 135px;\n}\n.pb-140 {\n\tpadding-bottom: 140px;\n}\n.pb-145 {\n\tpadding-bottom: 145px;\n}\n.pb-150 {\n\tpadding-bottom: 150px;\n}\n.pb-155 {\n\tpadding-bottom: 155px;\n}\n.pb-160 {\n\tpadding-bottom: 160px;\n}\n.pb-165 {\n\tpadding-bottom: 165px;\n}\n.pb-170 {\n\tpadding-bottom: 170px;\n}\n.pb-175 {\n\tpadding-bottom: 175px;\n}\n.pb-180 {\n\tpadding-bottom: 180px;\n}\n.pb-185 {\n\tpadding-bottom: 185px;\n}\n.pb-190 {\n\tpadding-bottom: 190px;\n}\n.pb-195 {\n\tpadding-bottom: 195px;\n}\n.pb-200 {\n\tpadding-bottom: 200px;\n}\n\n\n\n/*-- Padding Left --*/\n.pl-0 {\n\tpadding-left: 0px;\n}\n.pl-5 {\n\tpadding-left: 5px;\n}\n.pl-10 {\n\tpadding-left: 10px;\n}\n.pl-15 {\n\tpadding-left: 15px;\n}\n.pl-20{\n\tpadding-left: 20px;\n}\n.pl-25 {\n\tpadding-left: 35px;\n}\n.pl-30 {\n\tpadding-left: 30px;\n}\n.pl-35 {\n\tpadding-left: 35px;\n}\n\n.pl-35 {\n\tpadding-left: 35px;\n}\n\n.pl-40 {\n\tpadding-left: 40px;\n}\n\n.pl-45 {\n\tpadding-left: 45px;\n}\n\n.pl-50 {\n\tpadding-left: 50px;\n}\n\n.pl-55 {\n\tpadding-left: 55px;\n}\n\n.pl-60 {\n\tpadding-left: 60px;\n}\n.pl-65 {\n\tpadding-left: 65px;\n}\n.pl-70 {\n\tpadding-left: 70px;\n}\n.pl-75 {\n\tpadding-left: 75px;\n}\n.pl-80 {\n\tpadding-left: 80px;\n}\n.pl-85 {\n\tpadding-left: 80px;\n}\n.pl-90 {\n\tpadding-left: 90px;\n}\n.pl-95 {\n\tpadding-left: 95px;\n}\n.pl-100 {\n\tpadding-left: 100px;\n}\n\n\n/*-- Padding Right --*/\n.pr-0 {\n\tpadding-right: 0px;\n}\n.pr-5 {\n\tpadding-right: 5px;\n}\n.pr-10 {\n\tpadding-right: 10px;\n}\n.pr-15 {\n\tpadding-right: 15px;\n}\n.pr-20{\n\tpadding-right: 20px;\n}\n.pr-25 {\n\tpadding-right: 35px;\n}\n.pr-30 {\n\tpadding-right: 30px;\n}\n.pr-35 {\n\tpadding-right: 35px;\n}\n\n.pr-35 {\n\tpadding-right: 35px;\n}\n\n.pr-40 {\n\tpadding-right: 40px;\n}\n\n.pr-45 {\n\tpadding-right: 45px;\n}\n\n.pr-50 {\n\tpadding-right: 50px;\n}\n\n.pr-55 {\n\tpadding-right: 55px;\n}\n\n.pr-60 {\n\tpadding-right: 60px;\n}\n.pr-65 {\n\tpadding-right: 65px;\n}\n.pr-70 {\n\tpadding-right: 70px;\n}\n.pr-75 {\n\tpadding-right: 75px;\n}\n.pr-80 {\n\tpadding-right: 80px;\n}\n.pr-85 {\n\tpadding-right: 80px;\n}\n.pr-90 {\n\tpadding-right: 90px;\n}\n.pr-95 {\n\tpadding-right: 95px;\n}\n.pr-100 {\n\tpadding-right: 100px;\n}\n\n/* font weight */\n.f-700{font-weight: 700;}\n.f-600{font-weight: 600;}\n.f-500{font-weight: 500;}\n.f-400{font-weight: 400;}\n.f-300{font-weight: 300;}\n\n/* Background Color */\n\n.gray-bg {\n\tbackground: #f7f7fd;\n}\n.white-bg {\n\tbackground: #fff;\n}\n.black-bg {\n\tbackground: #222;\n}\n.theme-bg {\n\tbackground: #222;\n}\n.primary-bg {\n\tbackground: #222;\n}\n/* Color */\n\n.white-color {\n\tcolor: #fff;\n}\n.black-color {\n\tcolor: #222;\n}\n.theme-color {\n\tcolor: #222;\n}\n.primary-color {\n\tcolor: #222;\n}\n/* black overlay */\n\n[data-overlay] {\n\tposition: relative;\n}\n[data-overlay]::before {\n\tbackground: #000 none repeat scroll 0 0;\n\tcontent: \"\";\n\theight: 100%;\n\tleft: 0;\n\tposition: absolute;\n\ttop: 0;\n\twidth: 100%;\n\tz-index: 1;\n}\n[data-overlay=\"3\"]::before {\n\topacity: 0.3;\n}\n[data-overlay=\"4\"]::before {\n\topacity: 0.4;\n}\n[data-overlay=\"5\"]::before {\n\topacity: 0.5;\n}\n[data-overlay=\"6\"]::before {\n\topacity: 0.6;\n}\n[data-overlay=\"7\"]::before {\n\topacity: 0.7;\n}\n[data-overlay=\"8\"]::before {\n\topacity: 0.8;\n}\n[data-overlay=\"9\"]::before {\n\topacity: 0.9;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
